import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useChatStatus } from '@/hooks/api'

export function useAiAssistantWidget() {
  const { t, i18n } = useTranslation('dashboard')
  const { data: status, isLoading } = useChatStatus()

  const usagePercent = status ? Math.round((status.usage.used / status.usage.limit) * 100) : 0

  const resetDate = useMemo(() => {
    const now = new Date()
    const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1)
    return nextMonth.toLocaleDateString(i18n.language === 'bg' ? 'bg-BG' : 'en-GB', {
      day: 'numeric',
      month: 'long',
    })
  }, [i18n.language])

  return { t, status, isLoading, usagePercent, resetDate }
}
